import React, {Fragment, useState, useEffect} from "react";
import Breadcrumb from "../../common/breadcrumb/breadcrumb";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";

import {ToastContainer, toast} from "react-toastify";


import DataTable from "react-data-table-component";
import {gruppi} from "../../../api/groups";
import groupUtil from './gruppiutils';


const Gruppi = (props) => {
const columns = [
  {
    name: "Nome",
    selector: "name",
    sortable: true,
    center: true,
    className: "default-text mb-0 f-w-700 f-18",
    style: 'color: var(--primary-color);font-weight: 700;font-size: 14px;',
    width: '15%'

  },

  {
    name: "Azioni",
    selector: "id",
    sortable: true,
    center: true,
    format: (row) => {
      return (
        <>
                <Button color="warning"
                    className="btn btn-pill btn-sm btn-air-warning btn-warning"
                    onClick={loadFormEdit.bind(this, row)}>Gestisci</Button>
          &nbsp;
          <Button color="primary"
                  className="btn btn-pill btn-sm btn-air-danger  btn-danger"
                  onClick={deletegroup.bind(this, row.id)}>Elimina</Button>
        </>
      )
    },
  },
];

  const [id, setId] = useState();
  const [last10gruppi, setLast10Gruppi] = useState([]);
  const [name, setName] = useState('');
  const [isloading, setIsLoading] = useState(false);

  useEffect(async () => {
    await load();
  }, []);

  const load = async () => {
    try {
      const listagruppi = await gruppi.methods.loadGruppi();
      console.log('listaGruppi: ', listagruppi);
      // let listagruppi = listagruppiraw.sort(function (a, b) {
      //   // Turn your strings into dates, and then subtract them
      //   // to get a value that is either negative, positive, or zero.
      //   return new Date(b.timestamp) - new Date(a.timestamp);
      // })
      listagruppi.length = (listagruppi.length > 10 ? 10 : listagruppi.length);
      console.log(listagruppi)
      setLast10Gruppi(listagruppi);
    } catch (e) {
      toast.error('Impossibile recuperare i gruppi creati')
      setLast10Gruppi([]);

    }


  }

  const deletegroup = async (id) => {
    try{
      if(await gruppi.methods.deleteGruppo(id)){
        setTimeout(() => {
          toast.success(
            'Gruppo cancellato'
          );
        }, 300);
        load();
      }else{
        toast.error(
          'Il gruppo ha sessioni o utenti associati'
        );
      }
      
    }catch(e){
      toast.error(
        'Il gruppo ha sessioni o utenti associati'
      );
      console.log(e);
    }
    
  }


  const clearForm = () => {
    setId();
    setName('')
  }

  const loadFormEdit = (row) => {
    setId(row.id);
    setName(row.name)
  }

  const submit = async () => {

    setIsLoading(true)
    const inputobject = {name};
    if(id) inputobject.id=(id);
    const validateresult = groupUtil.methods.validateGruppo(inputobject);
    if (validateresult.length) {
      console.log(2);
      //TODO gestire validate field su campo input
      validateresult.forEach((e) => {
          console.log(e);
          toast.error(
            e.field + ':' + e.error
          );
        }
      );
      setIsLoading(false)
      return;
    }
    try {
      const result = await gruppi.methods.saveGruppo(inputobject);
      toast.success("Gruppo salvata...");
      clearForm();
      await load();
    } catch (e) {
      toast.error("Qualcosa è andato storto...");
    } finally {
      setIsLoading(false)
    }
  }


  return (
    <Fragment>
      <Breadcrumb parent="Gruppi" title="Gestione" subtitle="Gruppi"/>
      <Container fluid={true}>
        <Row>

          <Col xs="12">
            <Card className="card-absolute">
              <CardHeader className="bg-primary">
                <h5>Dati Gruppo {name}</h5>
              </CardHeader>
              <CardBody className="add-post">
                <Form id="savesession" className="row needs-validation">
                  <Col sm="12">
                    <Row>
                      <Col xs="12" sm="6" md="6" xl="6" lg="6">
                        <FormGroup>
                          <Label for="validationCustom01">Nome:</Label>
                          <Input
                            className="form-control"
                            id="input_nome_gruppo"
                            type="text"
                            placeholder=""
                            required={true}
                            value={name}
                            onChange={(e) => {
                              setName(e.target.value)
                            }}
                          />
                          <div className="valid-feedback">Ok!</div>
                        </FormGroup>

                      </Col>
                      {/* <Col xs="12" sm="6" md="6">

                      <FormGroup>
                          <Label for="validationCustom01">Cognome:</Label>
                          <Input
                            className="form-control"
                            id="input_cognome_gruppo"
                            type="text"
                            placeholder=""
                            required={true}
                            value={surname}
                            onChange={(e) => {
                              setSurname(e.target.value)
                            }}
                          />
                          <div className="valid-feedback">Ok!</div>
                        </FormGroup>

                      </Col> */}


                    </Row>

                  </Col>
                </Form>
                <Row>
                  &nbsp;
                </Row>
                <div className="btn-showcase" style={{textAlign: 'right'}}>
                  <Button disabled={isloading} id="buttonsubmit" color="primary btn-pill" type="button"
                          onClick={submit}>
                    Salva
                  </Button>
                  <Button color="danger btn-pill" type="reset" onClick={clearForm}>
                    Annulla
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>

        </Row>
        <Row>
          <Col xs="12" sm="12">
            <Card className="card-absolute">
              <CardHeader className="bg-secondary">
                <h5>Lista Gruppi</h5>
              </CardHeader>
              <CardBody className="add-post">
                <DataTable
                  columns={columns}
                  data={last10gruppi.filter((group, ix) => ix < 10)}
                  striped={true}
                  center={true}
                  className="table-xs table table-styling"
                  style={{
                    marginTop: "0px",
                    maxWidth: "100%",
                    overflow: 'auto',
                    width: '100%',
                    position: 'relative',
                    top: '-55px'
                  }}
                  pagination={true}
                  paginationPerPage={5}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <ToastContainer/>
      </Container>
    </Fragment>
  );
};

export default Gruppi;

